import { useState } from "react";
import { hasPermission } from "../firebase/firestore/permisions";
import { LoadingPage } from "./small-widgets";

export default function HasPermissions({permision, children}) {
    const [hasPermissionB, setHasPermissionB] = useState(null);

    async function checkPermission() {
        const result = await hasPermission(permision);
        setHasPermissionB(result);
    }

    if (hasPermissionB === null) {
        checkPermission();
        return <LoadingPage/>
    } else if (hasPermissionB === true) {
        return children;
    } else {
        return <div>
            <h1>No tienes permisos para acceder a esta página</h1>
        </div>;
    }
}